import NiceModal from '@ebay/nice-modal-react';
import { useModal } from '@ebay/nice-modal-react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import V2ThemeProvider from 'components/v2/ThemeProvider';
import { ReactComponent as CloseIcon } from 'components/v2/Icons/svg/close.svg';
import { ReactComponent as CheckCircleIcon } from 'components/v2/Icons/svg/check_circle.svg';

const paperSx = {
  borderRadius: 1,
  border: '1px solid',
  borderColor: 'divider',
  backgroundColor: 'darkSand.white80',
  boxShadow: '0px 4px 16px rgba(0,0,0,0.2)',
  maxWidth: 960,
  width: '100%',
  p: 1.5,
};

export default NiceModal.create(function EdgeEnquiryConfirmModal() {
  const modal = useModal();

  return (
    <V2ThemeProvider>
      <Dialog
        open={modal.visible}
        onClose={modal.hide}
        TransitionProps={{ onExited: modal.remove }}
        PaperProps={{
          sx: paperSx,
          'data-test-id': 'edge-enquiry-confirm-modal',
        }}
      >
        <Stack gap={1.5}>
          <Stack direction="row" gap={1.5} alignItems="center">
            <Box component={CheckCircleIcon} width={24} height={24} sx={{ color: 'success.main', flexShrink: 0 }} />
            <Typography variant="body1" sx={{ fontSize: '20px', flex: 1 }}>
              Enquiry Submitted
            </Typography>
            <IconButton size="small" onClick={modal.hide} aria-label="close">
              <CloseIcon width={16} height={16} style={{ color: 'currentColor' }} />
            </IconButton>
          </Stack>
          <Typography variant="body2" sx={{ letterSpacing: '0.14px' }}>
            {"Your custom itinerary request has been sent to Wilderness. They'll respond via email within one business day."}
          </Typography>
        </Stack>
      </Dialog>
    </V2ThemeProvider>
  );
});
